module.exports = __webpack_public_path__ + "28de9d3789aeef921bf2dc497451beb3.png";